module.exports = __webpack_public_path__ + "static/media/linkedin-icon.ded25776.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/social-icons/linkedin-icon.svg
// module id = 421
// module chunks = 0